export default __webpack_public_path__ + "static/media/Boots of the Deathstalker.ea870544.jpg";